import Swal from "sweetalert2";
import apiMarim from "../../../services/service_undefined_v2";
import moment from "moment";
import pen from "../../../assets/pen.png";
import search from "../../../assets/search.png";

export default {
  components: {
    pen,
    search
  },
  data() {
    return {
      hostshift: "",
      listRiceMar: [],
      saleRiceMar: [],
      calendar_time: moment(new Date()),
      form: { riceRemain: null, riceWaste: null, riceSteamed: null },
      sales: {}, // ← เก็บยอดขายตาม id
      now_date: moment(new Date()),
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      hasSaved: false // ก่อนบันทึกจะแสดง "รอบันทึก"
    };
  },
  created() {
    this.checkUser();
    if (sessionStorage.hostshift) {
      this.hostshift = JSON.parse(sessionStorage.hostshift);
    } else {
      this.$router.push("/");
    }
  },
  computed: {},
  methods: {
    statusBadgeClass(b) {
      if (!this.hasSaved) return "badge bg-secondary";
      switch (b.statusType) {
        case "equal":
          return "badge bg-success";
        case "less":
          return "badge bg-danger";
        case "more":
          return "badge bg-warning text-dark";
        default:
          return "badge bg-secondary";
      }
    },
    handleSave() {
      const payload = {
        rice_remain: this.form.riceRemain ? this.form.riceRemain : 0,
        rice_steamed: this.form.riceSteamed ? this.form.riceSteamed : 0,
        rice_waste: this.form.riceWaste ? this.form.riceWaste : 0,
        date: moment(this.now_date).format("YYYY-MM-DD HH:mm:ss")
      };

      this.$store.commit("Loading");
      apiMarim.saveConfirmSaleRiceMar(
        {
          payload
        },
        this.header,
        results => {
          if (results.data.status) {
            this.$notification["success"]({
              message: "บันทึกข้อมูลสำเร็จ",
              description: "บันทึกข้อมูลสำเร็จ"
            });
            this.form.riceRemain = null;
            this.form.riceSteamed = null;
            this.form.riceWaste = null;
            this.getProductRiceMar();
          } else {
            this.$notification["warning"]({
              message: "บันทึกข้อมูลไม่สำเร็จ",
              description: "บันทึกข้อมูลไม่สำเร็จ"
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.$notification["warning"]({
            message: "บันทึกข้อมูลไม่สำเร็จ",
            description: "บันทึกข้อมูลไม่สำเร็จ"
          });
          this.$store.commit("Loading");
        }
      );
    },
    onFocus(id) {
      if (this.sales[id] === 0) {
        this.sales[id] = "";
      }
    },
    onBlur(id) {
      if (this.sales[id] === "" || this.sales[id] === null) {
        this.sales[id] = 0;
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    getProductRiceMar() {
      this.$store.commit("Loading");
      apiMarim.getProductRiceMar(
        "?current_date=" + moment(this.calendar_time).format("YYYY-MM-DD"),
        results => {
          // console.log(results);
          if (results.data.status) {
            this.listRiceMar = results.data.data;
            this.listRiceMar.forEach(b => {
              b.mar_date = moment(b.mar_date).format("HH:mm:ss");
            });
            // console.log(results.data.data);
          } else {
            this.isDisabled = true;
            this.$notification["warning"]({
              message: "ไม่สามารถดึงข้อมูลได้",
              description: "ไม่สามารถดึงข้อมูลได้"
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.isDisabled = true;
          this.$notification["warning"]({
            message: "ไม่สามารถดึงข้อมูลได้",
            description: "ไม่สามารถดึงข้อมูลได้"
          });
          this.$store.commit("Loading");
        }
      );
    },
    getProductRiceMarSummarySale() {
      // this.$store.commit("Loading");
      // apiMarim.getProductRiceMarSummarySale(
      //   {
      //     date : moment(this.now_date).format("YYYY-MM-DD")
      //   },
      //   this.header,
      //   results => {
      //     if (results.data.status) {
      //       this.saleRiceMar = results.data.data;
      //     } else {
      //       this.$notification["warning"]({
      //         message: "ไม่สามารถดึงข้อมูลได้",
      //         description: "ไม่สามารถดึงข้อมูลได้"
      //       });
      //     }
      //     this.$store.commit("Loading");
      //   },
      //   errors => {
      //     console.log(errors);
      //     this.$notification["warning"]({
      //       message: "ไม่สามารถดึงข้อมูลได้",
      //       description: "ไม่สามารถดึงข้อมูลได้"
      //     });
      //     this.$store.commit("Loading");
      //   }
      // );
    },
    handleDeleteMar(id) {
      Swal.fire({
        title: "ลบข้อมูลการหม่าข้าว",
        text: "ท่านต้องการลบข้อมูลการหม่าข้าวใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          apiMarim.deleteSaleRiceMar(
            {
              id: id
            },
            this.header,
            results => {
              if (results.data.status) {
                this.$notification["success"]({
                  message: "ลบข้อมูลสำเร็จ",
                  description: "ลบข้อมูลสำเร็จ"
                });
                this.getProductRiceMar();
              } else {
                this.$notification["warning"]({
                  message: "ลบข้อมูลไม่สำเร็จ",
                  description: "ลบข้อมูลไม่สำเร็จ"
                });
              }
            },
            errors => {
              this.$notification["warning"]({
                message: "ลบข้อมูลไม่สำเร็จ",
                description: "ลบข้อมูลไม่สำเร็จ"
              });
            }
          );
        }
      });
    }
  },
  mounted() {
    this.getProductRiceMar();
    // this.getProductRiceMarSummarySale();
    $("#ToolModalSaleRiceMar").on("show.bs.modal", function() {}.bind(this));
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/pos/confirm_sale_rice_mar.js